<template>
  <div
    class="container"
    :class="{ lightBackground: !isDarkMode, darkBackground: isDarkMode }"
  >
    <vue-title title="WOLF | Request account" />
    <div class="login">
      <img src="@/assets/wolf-darkMode.svg" alt="Logo" v-show="isDarkMode" />
      <img src="@/assets/wolf-lightMode.svg" alt="Logo" v-show="!isDarkMode" />
      <h4 :class="{ lightText: isDarkMode, darkText: !isDarkMode }">
        Request an account
      </h4>
      <form @submit.prevent="onSubmit">
        <input
          type="email"
          placeholder="Email"
          autocomplete="on"
          :class="{
            lightField: isDarkMode,
            darkField: !isDarkMode,
            lightInput: isDarkMode,
            darkInput: !isDarkMode
          }"
          v-model="email"
          required
        />
        <button>Request Account</button>
      </form>
      <router-link
        to="/signin"
        :class="{ lightLink: isDarkMode, darkLink: !isDarkMode }"
        >Already have an account? Sign in now</router-link
      >
      <ThemeSwitch />
    </div>
  </div>
</template>

<script>
import ThemeSwitch from "@/components/ThemeSwitch";
import VueTitle from "@/components/VueTitle";

export default {
  name: "Request",
  components: {
    ThemeSwitch,
    VueTitle
  },
  data() {
    return {
      email: null,
      hasText: false,
      text: ""
    };
  },
  computed: {
    isDarkMode() {
      return this.$store.getters.isDarkMode;
    }
  },
  methods: {
    onSubmit() {
      const email = this.email;

      let slackUrl = new URL("https://slack.com/api/chat.postMessage");
      const data = {
        token: "xoxb-1520661221287-1535618774803-eL2dLZyXVarm9YDGVSA9CA4S",
        channel: "siterequest",
        text: `${email} has requested admin acces to HQ. Add this account to Netlify`
      };

      slackUrl.search = new URLSearchParams(data);

      fetch(slackUrl)
        .then(() => {
          this.$router.push({
            name: "signin",
            params: {
              userRequestedAccount: true,
              email: email
            }
          });
        })
        .catch(error => {
          alert("Error: " + error);
        });
    }
  },
  mounted() {
    const params = this.$route.params;
    if (params.userLoggedOut) {
      this.hasText = true;
      this.text = "You are no longer logged in.";
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: top;
  min-height: 100vh;
  padding-bottom: 24px;
  padding-top: 120px;
}
.login {
  width: 400px;
  text-align: center;
  margin-left: 16px;
  margin-right: 16px;
}

img {
  width: 150px;
  padding-bottom: 50px;
}
</style>
